export type TypeProfile = 'EMEDE' | 'CLIENTE';

export class PerfilParmDTO {
  id: number;
  descricao: string;
  tipo: 'EMEDE'|'CLIENTE';
  ativo: boolean;
  idsFuncionalidades:Array<number>;
  acessaTodosPerfis: boolean;
  idsPerfisPodeAcessar: Array<number>;
  tipoLoginAcesso: boolean;
}
